import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AdminService } from '../../../_services/admin.service';
import { ACLFeature } from '../../../_models/acl-feature';
import { Permissions } from '../../../_services/permissions';
import { SelectCompany } from '../impersonate/selectCompany';
import {IFamily} from '../../../_models/drilldown';

@Component({
    selector: 'edit-es-flush',
    styleUrls: ['flush.less'],
    templateUrl: 'flush.component.html',
})
export class FlushComponent implements OnInit, OnDestroy {

    @Input() regions;
    baseUrl = environment.BASE_URL;
    spcEndpoint = environment.SPC_ENDPOINT;
    iCanFlush = false;
    iCanFlushAllRegions = false;
    iCanFlushCompanies = false;
    iCanRoyalFlush = false;
    iCanFlushSpc = false;
    companies: Array<SelectCompany> = [];
    selectedCompany: SelectCompany;
    showConfirmModal = false;
    dataIndexingInfo?: String;
    dataFullIndexingInfo?: String;
    dataStatus?: String;

    constructor(
        private admin: AdminService,
        private permissions: Permissions
    ) {}

    ngOnInit() {
      this.permissions.hasFeature(ACLFeature.REGION_FLUSH)
        .subscribe((success) => {
          this.iCanFlush = success;
        });

      this.permissions.hasFeature(ACLFeature.GLOBAL_REGION_FLUSH)
        .subscribe((success) => {
          this.iCanFlushAllRegions = success;
        });

      this.permissions.hasFeature(ACLFeature.COMPANY_FLUSH)
        .subscribe((success) => {
          this.iCanFlushCompanies = success;
        });

      this.permissions.hasFeature(ACLFeature.ROYAL_FLUSH)
          .subscribe((success) => {
          this.iCanRoyalFlush = success;
      });

      this.permissions.hasFeature(ACLFeature.SPC_FLUSH)
          .subscribe((success) => {
          this.iCanFlushSpc = success;
      });

      if (this.iCanFlushCompanies) {
          this.admin.getCompanies().subscribe((companies) => {
              this.companies = companies.map((item: {id: string, name: string}) => {
                  return new SelectCompany(item.id, item.name);
              });
          });
      }
    }

  onCompanyChange(event) {
    this.selectedCompany = event;
  }

  public showConfirmModalClick() {
      this.showConfirmModal = true;
  }

  public onConfirmed(confirmed) {
      this.showConfirmModal = false;
      if (confirmed) {
        this.handleFullIndexing();
      }
  }

  parseEsEndpointResponse(response: any): any {
    if (response["status"] != "200" || response["_body"] == undefined) {
      return response;
    }
    return JSON.parse(response["_body"]);
  }

  handleRegionIndexing(company: string, region: string) {
    this.dataIndexingInfo = `Indexing data for ${region}...`;
    this.admin.indexElasticsearch(company, region).subscribe((response) => {
      this.dataIndexingInfo = JSON.stringify(this.parseEsEndpointResponse(response), null, 4)
        .replace(/\n/g, "<br>")
        .replace(/ /g, "&nbsp;");
    });
  }

  handleFullIndexing() {
    this.dataFullIndexingInfo = `Indexing data...`;
    this.admin.indexElasticsearch("all", "all").subscribe((response) => {
      this.dataFullIndexingInfo = JSON.stringify(this.parseEsEndpointResponse(response), null, 4)
        .replace(/\n/g, "<br>")
        .replace(/ /g, "&nbsp;");
    });
  }

  handleStatusCheck() {
    this.dataStatus = `Retrieving status...`;
    this.admin.checkElastisearchIndexStatus().subscribe((response) => {
      this.dataStatus = JSON.stringify(this.parseEsEndpointResponse(response), null, 4)
        .replace(/\n/g, "<br>")
        .replace(/ /g, "&nbsp;");
    })
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/management/components/flush/flush.component.ts